module.exports = __webpack_public_path__ + "media/assets/images/result-blue-d1f8d14d54ae08f83e720fdde22ba74e.svg";